import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/SWITCH-ROOM';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (payload: {
        onlyChildrenSelected: boolean;
        selectedChildrenIds: string[];
        selectedEmployeesIds: string[];
        institutionId: string;
    }) => payload,
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
